import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import { AssessmentProvider } from './context/AssessmentContext';
import { AuthProvider } from './context/AuthContext';
import ExamPage from './pages/ExamPage.jsx';
import InstructionsPage from './pages/InstructionsPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import ThankYouPage from './pages/ThankYouPage.jsx';
import SelfIntroPage from './pages/SelfIntroPage.jsx';

const App = () => (
  <AuthProvider>
    <AssessmentProvider>
      <Router>
        <Switch>
          <Route exact path="/">
            <Redirect to="/instructions" />
          </Route>
          <Route path="/login" component={LoginPage} />
          <ProtectedRoute path="/instructions" component={InstructionsPage} />
          <ProtectedRoute path="/self-intro" component={SelfIntroPage} />
          <ProtectedRoute path="/exam" component={ExamPage} />
          <ProtectedRoute path="/thank-you" component={ThankYouPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </AssessmentProvider>
  </AuthProvider>
);

export default App;
